<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="我的"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack('/')"
      />
      <div>
        <div class="home-user">
          <div class="headpic" @click="clickUser">
            <div>
              <van-image
                round
                width="4rem"
                height="4rem"
                :src="member.headpic"
              />
              <div class="text-center">{{ member.nickname || '请登录' }}</div>
            </div>
          </div>
          <!-- {{member.id}} -->
          <!-- {{$store.state.member}}
          {{$store.getters.mtoken}} -->
          <div v-if="!stuList.length" class="order-count">
            <div class="text-center">还未绑定学籍信息~</div>
          </div>
          <div v-if="stuList.length == 1" class="order-count" @click="$router.push('/stu-main/'+ stuList[0].id)">
            <div class="text-center">我的学籍</div>
            <div class="count text-center">{{ stuList[0]._rolls.length }}</div>
          </div>
          <div v-if="stuList.length > 1" class="order-count">
            <div class="text-center">学生信息</div>
            <div class="count text-center">{{ stuList.length }}</div>
          </div>
          <div class="logout">
            <a href="javascript:;" class="text-danger" @click="doLogout">退出</a>
          </div>
        </div>
      </div>
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        style="height:100%;"
      >
        <van-cell-group>
          <template v-for="stu in stuList">
            <van-cell :key="stu.id" is-link center :to="'/stu-main/'+ stu.id" class="stu-item">
              <van-row>
                <!-- <van-col span="8">
                  <van-image
                    width="90%"
                    :src="stu.pic ? rootPath + stu.pic : noimg"
                  />
                </van-col> -->
                <van-col span="24">
                  <div>
                    <p><van-tag type="danger">{{ stu._rolls.length }}</van-tag> 学籍</p>
                    <p><span class="text-gray">姓　名：</span>{{ stu.name }}</p>
                    <p><span class="text-gray">性　别：</span>{{ stu.sexname }}</p>
                    <!-- <p>身份证：{{ stu.sfzh }}</p> -->
                    <p><span class="text-gray">手机号：</span>{{ stu.mobile }}</p>
                    <p><span class="text-gray">微信号：</span>{{ stu.weixin }}</p>
                  </div>
                </van-col>
              </van-row>
            </van-cell>
          </template>
        </van-cell-group>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
export default {
  components: {
  },
  mixins: [siteMixin],
  data() {
    return {
      error: false,
      isLoading: false,
      stuList: {},
    }
  },
  computed: {
    ...mapGetters({
      reloadWeb: [types.OTHER.reloadWeb],
    }),
  },
  watch: {
    reloadWeb() {
      this.loadData();
    }
  },
  activated() {
    
  },
  mounted () {
    this.loadData();
    this.$bus.$on('loginok', () => {
      this.loadData();
    });
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'site/home',
        data: {},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.setData(json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    clickUser() {
      if (!this.member.id) {
        this.doLogin();
      }
    },
    setData(json) {
      let list = json.stuList || [];
      list.map(d => {
        d._rolls = d._rolls ? JSON.parse(d._rolls) : [];
      });
      this.stuList = list;
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        this.setData(json);
        this.$toast('刷新成功');
      });
    },
    doLogout() {
      this.$store.dispatch('memberLogout', {
        callback: (flag) => {
          if (flag) {
            this.$toast('已退出登录！');
            this.stuList = [];
          }
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-top:50px;
  height:calc(100vh - 50px);
  background-color:#f5f5f5;
}
.home-user {
  .flex-center-v();
  margin:1rem;
  padding:1rem;
  background-color:#fff;
  border-radius:1rem;
  .shadow_black(0 0 10px 0, .05);
  .headpic {
    flex-shrink: 0;
    margin-right:1.5rem;
  }
  .order-count {
    flex-grow: 1;
    padding-left: 1rem;
    border-left: 1px #eee solid;
  }
  .count {
    color:green;
    .fontsize(2rem);
  }
  .logout {
    margin-left: 2rem;
    flex-shrink: 0;
  }
  .text-danger {
    color: #ff6c6c;
  }
}
/*.roll-item{
  padding:1rem;
  background-color:#fff;
}*/
/deep/ .stu-item::before {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background-size: 80px;
  content: '';
}
</style>